/**
 * Store data – places where 12GO sets can be purchased.
 * region: pl = Poland, de = Germany, eu = Europe, us = USA, ca = Canada, worldwide
 */

import type { MessageKey } from "@/lib/i18n";

export type StoreRegion = "pl" | "de" | "eu" | "us" | "ca" | "worldwide";

export type Store = {
  id: string;
  href: string;
  labelKey: MessageKey;
  descKey: MessageKey;
  regions: StoreRegion[];
  logoSrc: string;
};

type HomepagePartner = {
  id: string;
  href: string;
  labelKey: MessageKey;
  logoSrc: string;
};

export const stores: Store[] = [
  {
    id: "aliexpress",
    href: "https://s.click.aliexpress.com/e/_c3My3BLH",
    labelKey: "home.partnerAliExpress",
    descKey: "whereToBuy.aliexpressDesc",
    regions: ["worldwide"],
    logoSrc: "/images/partners/aliexpress.svg",
  },
  {
    id: "afobrick",
    href: "https://afobrick.com/search?type=product&options%5Bprefix%5D=last&ref=pbricks&options%5Bunavailable_products%5D=last&q=12go",
    labelKey: "home.partnerAfobrick",
    descKey: "whereToBuy.afobrickDesc",
    regions: ["worldwide"],
    logoSrc: "/images/partners/afobrick.png",
  },
  {
    id: "yourwobb",
    href: "https://yourwobb.com/search?coupon_code=PBricks&data_from=app_affiliate&q=12go&data_from=app_searchbox&page=1&utm_source=app_affiliate&utm_medium=3FA55BC1A8CD50497F68EC134605EA2A",
    labelKey: "home.partnerYourwobb",
    descKey: "whereToBuy.yourwobbDesc",
    regions: ["worldwide"],
    logoSrc: "/images/partners/yourwobb.png",
  },
  {
    id: "barweer",
    href: "https://www.barweer.com/search/?DIST=Q0ZGGFU%3D&Keyword=12go",
    labelKey: "home.partnerBarweer",
    descKey: "whereToBuy.barweerDesc",
    regions: ["worldwide"],
    logoSrc: "/images/partners/barweer.png",
  },
  {
    id: "amazon-eu",
    href: "https://amzn.to/4bWIg2L",
    labelKey: "home.partnerAmazonEU",
    descKey: "whereToBuy.amazonEuDesc",
    regions: ["eu"],
    logoSrc: "/images/partners/amazon.svg",
  },
  {
    id: "amazon-us",
    href: "https://amzn.to/4uEiokA",
    labelKey: "home.partnerAmazonUS",
    descKey: "whereToBuy.amazonUsDesc",
    regions: ["us"],
    logoSrc: "/images/partners/amazon.svg",
  },
];

/** Partner links shown on homepage (order matters) */
const HOMEPAGE_PARTNER_IDS = [
  "aliexpress",
  "afobrick",
  "yourwobb",
  "barweer",
  "amazon-eu",
  "amazon-us",
] as const;

export const HOMEPAGE_PARTNERS: HomepagePartner[] = HOMEPAGE_PARTNER_IDS.map((id) => {
  const store = stores.find((s) => s.id === id);
  if (!store) {
    throw new Error(`Missing store definition for homepage partner: ${id}`);
  }
  return {
    id: store.id,
    href: store.href,
    labelKey: store.labelKey,
    logoSrc: store.logoSrc,
  };
});

/** Order: World, Europe, USA */
export const STORE_REGIONS: StoreRegion[] = ["worldwide", "eu", "us"];

export function filterStoresByRegion(
  storesList: Store[],
  region: StoreRegion | null
): Store[] {
  if (!region) return storesList;
  return storesList.filter((s) =>
    s.regions.includes(region) ||
    (region === "eu" || region === "us") && s.regions.includes("worldwide")
  );
}
